(function(){
    'use strict';

    angular
    .module('appback')
    .controller('MaquinasController', MaquinasController)
 
    MaquinasController.$inject = ["GenerallabService","HormonasService","ListasService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function MaquinasController(GenerallabService,HormonasService,ListasService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
        vm.peticiones = [];
        vm.peticionesMarcadas = {};
        vm.getBio = function(){
            ListasService.getBioquimicas(function(data){

                vm.peticiones = data.peticiones;
                ////console.log(data);
            });
        }

        vm.getHorm = function(){
            HormonasService.getHormonas(function(data){

                vm.peticiones = data.peticiones;
                ////console.log(data);
            });
        }
        vm.initBio = function(){
                vm.getBio();
            /*setInterval(function(){
                vm.getBio();
            },10000)*/
        	
        }

        vm.initHorm = function(){
                vm.getHorm();
            /*setInterval(function(){
                vm.getBio();
            },10000)*/
            
        }

        vm.configModal = "";
        vm.config = function(peti){
            var analiticas_ids = [];
            for(var cont=0;cont<peti.analiticas.length;cont++){
                analiticas_ids.push(peti.analiticas[cont].analitica.id);
            }
            ListasService.getDeterminacionesByAnaliticas(peti.peticion,analiticas_ids,function(dataPet){
                vm.configModal = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title-top',
                    ariaDescribedBy: 'modal-body-top',
                    //windowClass: 'modal-danger',
                    //backdrop  : 'static',
                    templateUrl: 'dilucion.html',
                    //size: 'xlg',
                    controller: function($scope) {
                        $scope.determinaciones = dataPet.determinaciones;
                        //console.log(peti);
                        $scope.peticion = peti;
                        //$scope.dilucion = peti.peticion.dilucion;
                        
                        $scope.analiticasModificadasIds = [];
                        $scope.analiticaModificada = function(anal){
                            //console.log("anal",anal);
                            var key = $scope.analiticasModificadasIds.indexOf(anal.analitica.id);
                            if (key < 0) {
                                $scope.analiticasModificadasIds.push(anal.analitica.id);
                            }else{
                                $scope.analiticasModificadasIds.splice(key, 1);
                            }
                            //console.log("analiticasModificadasIds",$scope.analiticasModificadasIds);
                        }
                        $scope.okForm = function(){
                            var determinacionesFinal = [];
                            for(var cont=0;cont<$scope.determinaciones.length;cont++){
                                determinacionesFinal.push({"analitica_id":$scope.determinaciones[cont].id, "dilucion":$scope.determinaciones[cont].dilucion});
                            }
                            var petiFinal = { determinaciones: determinacionesFinal, peticion: peti.peticion, analiticas : [] };
                            for(var cont=0;cont<$scope.peticion.analiticas.length;cont++){
                                //var res = peti.analiticas[cont].pet.tachado;
                                //peti.analiticas[cont].pet.tachado = 1;
                                var key = $scope.analiticasModificadasIds.indexOf(peti.analiticas[cont].analitica.id);
                                if (key >= 0) {
                                    petiFinal.analiticas.push({pet: peti.analiticas[cont].pet});
                                }
                            }

                            //console.log("petiFinal",petiFinal);

                            ListasService.modificarConfigBioq(petiFinal,function(data){
                                ////console.log(data);
                            });
                            vm.configModal.close();
                        }
                        $scope.koForm = function(){
                            vm.configModal.close();
                        }
                    }
                  });

            });
            
        }


        vm.descartarModal = "";
        vm.nomuestra = function(peti){
            vm.descartarModal = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title-top',
                ariaDescribedBy: 'modal-body-top',
                //windowClass: 'modal-danger',
                //backdrop  : 'static',
                templateUrl: 'descartar.html',

                //size: 'xlg',
                controller: function($scope) {
                   
                    $scope.peticion = peti;
                    $scope.okForm = function(){
                        //console.log(peti);
                        var petiFinal = { peticion: peti.peticion, analiticas:[]};
                        peti.tachado = 1;
                        for(var cont=0;cont<$scope.peticion.analiticas.length;cont++){
                            var res = peti.analiticas[cont].pet.tachado;
                            peti.analiticas[cont].pet.tachado = 1;
                            if(res==0){
                                petiFinal.analiticas.push({pet: peti.analiticas[cont].pet})
                            }

                        }

                        ListasService.descartarMuestra(petiFinal,function(data){
                            ////console.log(data);
                        });
                        vm.descartarModal.close();
                    }
                    $scope.koForm = function(){
                        vm.descartarModal.close();
                    }
                }
              });
        }

        vm.marcarPeti = function(peti){
            if(typeof(vm.peticionesMarcadas[peti.peticion.lims_id]) == 'undefined'){
                vm.peticionesMarcadas[peti.peticion.lims_id] = { marcada : false };
            }
            vm.peticionesMarcadas[peti.peticion.lims_id] = { marcada : vm.peticionesMarcadas[peti.peticion.lims_id].marcada ? false : true };
        }

        vm.cambiarDilucion = function(peti){
            ListasService.cambiarDilucion(peti,function(data){
                ////console.log(data);
            });
        }
         

        vm.marcar = function(anal){
            ListasService.marcarBioquimica(anal.pet,function(data){
                ////console.log(data);
            });
            //anal.pet.tachado
        }
    }
  
})();